const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25642",
    transform: "translate(-319.5 -138.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(320 139)",
    style: {
      stroke: "#e0e0e0",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/PDF/36pt"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25643"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13618",
    d: "M420.172 13a2 2 0 0 1 1.414.586l7.828 7.828a2 2 0 0 1 .586 1.414V40a3.009 3.009 0 0 1-3 3h-18.015A3 3 0 0 1 406 40V16a3.009 3.009 0 0 1 3-3zm.828 1.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    transform: "translate(-70 139)",
    style: {
      fill: "#217346",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13619",
    d: "m413.637 36 2.9-5.36-2.72-5.072h2.624l.912 1.968c.117.245.235.507.352.784s.251.565.4.9h.064q.176-.5.336-.9.176-.416.336-.784l.832-1.968h2.512l-2.7 5.184L422.357 36h-2.624l-1.04-2.128q-.192-.416-.384-.816-.176-.416-.4-.9h-.064q-.176.48-.352.9a66.46 66.46 0 0 0-.352.816L416.165 36z",
    transform: "translate(-70 139)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExl);
export default __webpack_public_path__ + "static/media/exl.024c8818074c60558e19cffb6295c9cc.svg";
export { ForwardRef as ReactComponent };